/**@copyright : ToXSL Technologies Pvt. Ltd. < www.toxsl.com >
@author : Shiv Charan Panjeta < shiv@toxsl.com >
All Rights Reserved.
Proprietary and confidential : All information contained herein is, and remains
the property of ToXSL Technologies Pvt. Ltd. and its partners.
Unauthorized copying of this file, via any medium is strictly prohibited. */

import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ReactStars from "react-stars";
import Footer from "../../Commons/Footer";
import Loader from "../../Commons/Loader/Loader";
import {
  getProductDetailsAfterCheckout,
  ratingDetails,
} from "../../Services/APIServices";
import { BackIcon } from "../../SvgIcons/allIcons";
import { LENDER, RENTER } from "../../globals/constants";
import LenderHeader from "../../Commons/Headers/LenderHeader";
import RenterHeader from "../../Commons/Headers/RenterHeader";
import Header from "../../Commons/Headers/Header";
import useRole from "../../hooks/useRole";
import { imageBase } from "../../globals/Config";

const AddRatingmobile = () => {
  const role = useRole();
  const location = useLocation();
  const userDetail = useSelector((state) => state?.Login?.userDetails);
  const id = new URLSearchParams(location?.search).get("id");
  const pid = new URLSearchParams(location?.search).get("pid");
  const [product, setProduct] = useState("");
  const navigate = useNavigate();
  const [loading, setLoding] = useState(false);
  const [sliderImg, setSliderImg] = useState([]);

  useEffect(() => {
    ProductDetails();
  }, []);

  const ProductDetails = () => {
    getProductDetailsAfterCheckout(id).then((resp) => {
      if (resp?.data?.status === 200) {
        const tempArr = [];
        if (resp?.data?.data) {
          resp?.data?.data?.product_image?.map((data) => {
            if (data?.is_cover_photo) {
              tempArr.unshift({
                original: imageBase + data?.images,
                thumbnail: imageBase + data?.images,
              });
            } else {
              tempArr.push({
                original: imageBase + data?.images,
                thumbnail: imageBase + data?.images,
              });
            }
          });
        }
        setSliderImg(tempArr);
        setProduct(resp?.data?.data);
        if (userDetail?.role_id == RENTER) {
          RatingDetails(id);
        } else {
          RatingDetails(resp?.data?.data?.booked_by?.renter_id);
        }
      }
    });
  };

  const { handleSubmit, values, setFieldValue, setValues } = useFormik({
    initialValues: {
      product_id: "",
      user_id: "",
      rating: "",
      item_quality: "",
      communication: "",
      transport: "",
      value: "",
      item_maintained: "",
      punctuality: "",
      review: "",
      message: "",
    },
    onSubmit(values, { setSubmitting }) {
      setSubmitting(true);
      setLoding(true);
      let renterbody = {
        product_id: pid,
        rating: values?.rating,
        item_quality: values?.item_quality,
        communication: values?.communication,
        transport: values?.transport,
        review: values?.review,
        value: values?.value,
        message: values?.message,
      };

      let lenderbody = {
        user_id: product?.booked_by?.renter_id,
        rating: values?.rating,
        item_maintained: values?.item_maintained,
        communication: values?.communication,
        punctuality: values?.punctuality,
        review: values?.review,
        message: values?.message,
      };

      if (userDetail?.role_id == RENTER) {
        navigate(`/renter/addratingmobile2?id=${id}&pid=${pid}`, {
          state: renterbody,
        });
      } else {
        navigate(`/lender/addratingmobile2?id=${id}&pid=${pid}`, {
          state: lenderbody,
        });
      }
    },
  });

  const RatingDetails = (id) => {
    ratingDetails(id).then((resp) => {
      if (resp?.data?.status === 200) {
        setValues({
          ...values,
          rating: resp?.data?.data?.rating,
          item_quality: resp?.data?.data?.item_quality,
          communication: resp?.data?.data?.communication,
          transport: resp?.data?.data?.transport,
          review: resp?.data?.data?.review,
          value: resp?.data?.data?.value,
          item_maintained: resp?.data?.data?.item_maintained,
          punctuality: resp?.data?.data?.punctuality,
        });
      }
    });
  };

  return (
    <>
      {role == LENDER ? (
        <LenderHeader />
      ) : role == RENTER ? (
        <RenterHeader />
      ) : (
        <Header />
      )}
      <div className="category-detailview pb-3 pt-5">
        <Container>
          <Row>
            <Col lg={12}>
              <p className="head16 d-flex align-items-center justify-content-between gap-3">
                <a
                  href="#"
                  className="d-block d-lg-none d-md-none"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <BackIcon />
                </a>
                {/* <a href="#" className="text-black text-underline">
                  Save & Exit
                </a> */}
              </p>
              {userDetail?.role_id == RENTER ? (
                <>
                  <div className="d-flex mb-5 ratingcards">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xlink="http://www.w3.org/1999/xlink"
                    >
                      <rect width="40" height="40" fill="url(#pattern0)" />
                      <defs>
                        <pattern
                          id="pattern0"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            href="#image0_3522_22674"
                            transform="scale(0.02)"
                          />
                        </pattern>
                        <image
                          id="image0_3522_22674"
                          width="50"
                          height="50"
                          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAFK0lEQVRoge2aaWxVRRTHf121bNYFaqJ+UKFGDUZcUq2kSGqJhogoEY0WNS4UjVsiUT8IChpRjGvUqImpIiS4JBjE3RiXxD0qiEg0GlfciwqUWtpeP5wzzLxh7vXd23dbmvBPJnn3nDPnnJk79yzTwi7swk6FvYHPgKjEYw1QO1CLGAV8kMMizHgPGJn3IoYBbztGV8XIVQMvqcw3OiKlVcfMWeXofR2oKZnXAedeoHD3bgjIlQPLlf8rUA8cDGxQ2gqgMjBvnqf7ZWC3kq5ADa9wnPtRf08JyD6kvD+B8Q79CKBDeQ8DZd68FuX9gF3000BFqRZRDixTxX8BDUAn0Afs6cneqnJbgIkBXQ3AJpVZ5PH2AHqBrcAE4A+VW6I+9Atl2B02zh2tz+s82SuU/i9wcoLOZqBLZa/1eOuUfhRwJPYNPsqObzAVFquiTmCy0i5TWrsjNwt5Qz3AmUXonQ5s0zmzHXq76p6jz8dj3+DdmVYALFQF3cBUh/64Z2ya49TFKfSfr3N6gbOUNgf7BgxOQo5bBMxPtQLgKp3Y4xgxWK+8CchbMkbmpjXi2OkGTlGdEZJsXZyGbFboOMbiQmSn+oCLPF4tsoOdQCPwjypfmHYFDm7DfoOTgM1qY5Qn16r0PuxpiMUsR/jSAH+KGv0J+F1/35/JfYsy4BFsyDah98SAbBv2OLbGKTQfYARcFyMzn8KktZQShEYKk6gZcT64x36mz2zBhsQFCQafdwytBKoyOh5CFYWVwzMJsguwoX57IGpCznxeRWDeoxNoKtdVlawMGARUIGsAbJIz5UEcrla5F3N0zFTNbQky45Eo5+az7TBZ9Suk7glhJPA3EjkO7YezcahHItJGYHiCD18gvi4LCdQAH2M/5Lja5j6VeSC7v7F4UHUvjuGXIUEgAlYj/VEQY5HdSAp/Y5Fd2wLslc3fIGqRuqoHODBG5nr1bSPS4yTiVGzSaYmRMd3cNSmdTcJcksPuZGxNd3qxShdhm6j9A3zTBH1LuNtLiwpsO9wU4O+Lzfi3pFFcjrSaEfAu4T57jfLPSKM4BjNU1ycBXhX2nuA1MqSKMUjbGQH3BvhtynszreIA3lJdFwR4Jrh8D4zOaqABSTYRcJ7HG4ZtR4/JagBbuv8G7O7xzsaW+Y39sAHA5apsM3C4xzMleLs/KQUeUx03e/RDsG1CUnLMZOxLCpPlfshudQF1GfSORqqJbgqDyghs/740g95YuMnyWQqT5VNKn5dBr2kL3Axd5uhMTHpZMQ65DvLzxwlK20D8LWIIVdj7sQaHbvJJB0UkvayYhiSkbUhbamDugs9NoatV53zo0BqRY9aHNHq54nZ14BfkGwFpkSPgoxR63tc55+hzHdJC9/cOoGhUAK+owXeQ41QN/Ky0YsKkfxwrkXyUOellxRjs+b5TaTfq85NFzDcfs7kEv0ufvwP2KamnReA4bLKciSxuK/L9HJAwzw/Z05Fvogs4Nkd/E3ElspBNwGHYW0j/gtqFm0TrkUYtAi7J1dMiYJxfj0QyEzpDHV4NtqyZBHyuv58YEE//B8OBtYhDy7GVamiHZ2MLzSX6+1NySHpZ4SZLs5C17Ngur/ZkOoCDBs7N4jAD21maO6dmh9/s0Ht1TGUnxR0UXp6tdHjPebybBty7FKgE3sA624dEJnNhYeivMgQuBeuwyTIC7kE6TPM8KEkvKyYiSS9C8oTJFVvpXzc5KDDXq+7w/3A0ZGByRaS/hyxGIHdfX5Pjv2QMFMbpyBX/AaEUCPkzY/rBAAAAAElFTkSuQmCC"
                        />
                      </defs>
                    </svg>
                    <Form.Group>
                      <div className=" ps-4">
                        <h4 className="font24">
                          {/* What was the overall quality of the item? */}
                          Item Quality
                        </h4>
                        <div className="starslist smallsize">
                          <ReactStars
                            className="star_rating"
                            size={24}
                            count={5}
                            name="item_quality"
                            half={false}
                            onChange={(e) => {
                              setFieldValue("item_quality", e);
                            }}
                            value={values?.item_quality}
                            color2={"#16ff96"}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>

                  <div className="d-flex mb-5 ratingcards">
                    <svg
                      width="36"
                      height="28"
                      viewBox="0 0 36 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.33301 26.5H34.6663V1.5H1.33301V26.5Z"
                        stroke="black"
                        strokeWidth="2"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M1.33301 1.5L17.9997 14L34.6663 1.5"
                        stroke="black"
                        strokeWidth="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17.9997 1.5H1.33301V14M34.6663 14V1.5H17.9997"
                        stroke="black"
                        strokeWidth="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <Form.Group>
                      <div className=" ps-4">
                        <h4 className="font24">
                          {/* How well did{" "}
                          {userDetail?.role_id === RENTER
                            ? product?.created_by_name
                            : product?.booked_by?.renter_name}{" "}
                          Communicate? */}
                          Lender Communication
                        </h4>
                        <div className="starslist smallsize">
                          <ReactStars
                            className="star_rating"
                            size={24}
                            half={false}
                            count={5}
                            name="communication"
                            onChange={(e) => {
                              setFieldValue("communication", e);
                            }}
                            value={values?.communication}
                            color2={"#16ff96"}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>

                  <div className="d-flex mb-5 ratingcards">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xlink="http://www.w3.org/1999/xlink"
                    >
                      <rect width="40" height="40" fill="url(#pattern0)" />
                      <defs>
                        <pattern
                          id="pattern0"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            href="#image0_3274_25136"
                            transform="scale(0.015625)"
                          />
                        </pattern>
                        <image
                          id="image0_3274_25136"
                          width="64"
                          height="64"
                          href="data:image/png;base64,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"
                        />
                      </defs>
                    </svg>
                    <Form.Group>
                      <div className=" ps-4">
                        <h4 className="font24">
                          {/* How was the delivery and return process? */}
                          Delivery and Returns
                        </h4>
                        <div className="starslist smallsize">
                          <ReactStars
                            className="star_rating"
                            size={24}
                            count={5}
                            half={false}
                            name="transport"
                            onChange={(e) => {
                              setFieldValue("transport", e);
                            }}
                            value={values?.transport}
                            color2={"#16ff96"}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>

                  <div className="d-flex mb-5 ratingcards">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xlink="http://www.w3.org/1999/xlink"
                    >
                      <rect width="40" height="40" fill="url(#pattern0)" />
                      <defs>
                        <pattern
                          id="pattern0"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            href="#image0_3274_25136"
                            transform="scale(0.015625)"
                          />
                        </pattern>
                        <image
                          id="image0_3274_25136"
                          width="64"
                          height="64"
                          href="data:image/png;base64,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"
                        />
                      </defs>
                    </svg>
                    <Form.Group>
                      <div className=" ps-4">
                        <h4 className="font24">
                          {/* Was the price paid fair for the item rented ? */}
                          Value
                        </h4>
                        <div className="starslist smallsize">
                          <ReactStars
                            className="star_rating"
                            size={24}
                            count={5}
                            half={false}
                            name="rating"
                            onChange={(e) => {
                              setFieldValue("rating", e);
                            }}
                            value={values?.rating}
                            color2={"#16ff96"}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                </>
              ) : (
                <>
                  <div className="d-flex mb-5 ratingcards">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xlink="http://www.w3.org/1999/xlink"
                    >
                      <rect width="40" height="40" fill="url(#pattern0)" />
                      <defs>
                        <pattern
                          id="pattern0"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            href="#image0_3522_22674"
                            transform="scale(0.02)"
                          />
                        </pattern>
                        <image
                          id="image0_3522_22674"
                          width="50"
                          height="50"
                          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAFK0lEQVRoge2aaWxVRRTHf121bNYFaqJ+UKFGDUZcUq2kSGqJhogoEY0WNS4UjVsiUT8IChpRjGvUqImpIiS4JBjE3RiXxD0qiEg0GlfciwqUWtpeP5wzzLxh7vXd23dbmvBPJnn3nDPnnJk79yzTwi7swk6FvYHPgKjEYw1QO1CLGAV8kMMizHgPGJn3IoYBbztGV8XIVQMvqcw3OiKlVcfMWeXofR2oKZnXAedeoHD3bgjIlQPLlf8rUA8cDGxQ2gqgMjBvnqf7ZWC3kq5ADa9wnPtRf08JyD6kvD+B8Q79CKBDeQ8DZd68FuX9gF3000BFqRZRDixTxX8BDUAn0Afs6cneqnJbgIkBXQ3AJpVZ5PH2AHqBrcAE4A+VW6I+9Atl2B02zh2tz+s82SuU/i9wcoLOZqBLZa/1eOuUfhRwJPYNPsqObzAVFquiTmCy0i5TWrsjNwt5Qz3AmUXonQ5s0zmzHXq76p6jz8dj3+DdmVYALFQF3cBUh/64Z2ya49TFKfSfr3N6gbOUNgf7BgxOQo5bBMxPtQLgKp3Y4xgxWK+8CchbMkbmpjXi2OkGTlGdEZJsXZyGbFboOMbiQmSn+oCLPF4tsoOdQCPwjypfmHYFDm7DfoOTgM1qY5Qn16r0PuxpiMUsR/jSAH+KGv0J+F1/35/JfYsy4BFsyDah98SAbBv2OLbGKTQfYARcFyMzn8KktZQShEYKk6gZcT64x36mz2zBhsQFCQafdwytBKoyOh5CFYWVwzMJsguwoX57IGpCznxeRWDeoxNoKtdVlawMGARUIGsAbJIz5UEcrla5F3N0zFTNbQky45Eo5+az7TBZ9Suk7glhJPA3EjkO7YezcahHItJGYHiCD18gvi4LCdQAH2M/5Lja5j6VeSC7v7F4UHUvjuGXIUEgAlYj/VEQY5HdSAp/Y5Fd2wLslc3fIGqRuqoHODBG5nr1bSPS4yTiVGzSaYmRMd3cNSmdTcJcksPuZGxNd3qxShdhm6j9A3zTBH1LuNtLiwpsO9wU4O+Lzfi3pFFcjrSaEfAu4T57jfLPSKM4BjNU1ycBXhX2nuA1MqSKMUjbGQH3BvhtynszreIA3lJdFwR4Jrh8D4zOaqABSTYRcJ7HG4ZtR4/JagBbuv8G7O7xzsaW+Y39sAHA5apsM3C4xzMleLs/KQUeUx03e/RDsG1CUnLMZOxLCpPlfshudQF1GfSORqqJbgqDyghs/740g95YuMnyWQqT5VNKn5dBr2kL3Axd5uhMTHpZMQ65DvLzxwlK20D8LWIIVdj7sQaHbvJJB0UkvayYhiSkbUhbamDugs9NoatV53zo0BqRY9aHNHq54nZ14BfkGwFpkSPgoxR63tc55+hzHdJC9/cOoGhUAK+owXeQ41QN/Ky0YsKkfxwrkXyUOellxRjs+b5TaTfq85NFzDcfs7kEv0ufvwP2KamnReA4bLKciSxuK/L9HJAwzw/Z05Fvogs4Nkd/E3ElspBNwGHYW0j/gtqFm0TrkUYtAi7J1dMiYJxfj0QyEzpDHV4NtqyZBHyuv58YEE//B8OBtYhDy7GVamiHZ2MLzSX6+1NySHpZ4SZLs5C17Ngur/ZkOoCDBs7N4jAD21maO6dmh9/s0Ht1TGUnxR0UXp6tdHjPebybBty7FKgE3sA624dEJnNhYeivMgQuBeuwyTIC7kE6TPM8KEkvKyYiSS9C8oTJFVvpXzc5KDDXq+7w/3A0ZGByRaS/hyxGIHdfX5Pjv2QMFMbpyBX/AaEUCPkzY/rBAAAAAElFTkSuQmCC"
                        />
                      </defs>
                    </svg>
                    <Form.Group>
                      <div className=" ps-4">
                        <h4 className="font24">
                          How well did {product?.booked_by?.renter_name} take
                          care of your item ?
                        </h4>
                        <div className="starslist smallsize">
                          <ReactStars
                            className="star_rating"
                            size={24}
                            count={5}
                            name="item_quality"
                            half={false}
                            onChange={(e) => {
                              setFieldValue("item_quality", e);
                            }}
                            value={values?.item_quality}
                            color2={"#16ff96"}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="d-flex mb-5 ratingcards">
                    <svg
                      width="36"
                      height="28"
                      viewBox="0 0 36 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.33301 26.5H34.6663V1.5H1.33301V26.5Z"
                        stroke="black"
                        strokeWidth="2"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M1.33301 1.5L17.9997 14L34.6663 1.5"
                        stroke="black"
                        strokeWidth="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M17.9997 1.5H1.33301V14M34.6663 14V1.5H17.9997"
                        stroke="black"
                        strokeWidth="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <Form.Group>
                      <div className=" ps-4">
                        <h4 className="font24">
                          How well did {product?.booked_by?.renter_name}{" "}
                          Communicate?
                        </h4>
                        <div className="starslist smallsize">
                          <ReactStars
                            className="star_rating"
                            size={24}
                            half={false}
                            count={5}
                            name="communication"
                            onChange={(e) => {
                              setFieldValue("communication", e);
                            }}
                            value={values?.communication}
                            color2={"#16ff96"}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>

                  <div className="d-flex mb-5 ratingcards">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xlink="http://www.w3.org/1999/xlink"
                    >
                      <rect width="40" height="40" fill="url(#pattern0)" />
                      <defs>
                        <pattern
                          id="pattern0"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            href="#image0_3274_25136"
                            transform="scale(0.015625)"
                          />
                        </pattern>
                        <image
                          id="image0_3274_25136"
                          width="64"
                          height="64"
                          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAIiklEQVR4nO3be7Dmcx0H8Nc5dq292CXGtilhs3s2GkMkTLnUTkruEdlchlUqU1RTMzQmKSqGbpNMF11Gq0KlUYqwLrWh49piTdik0hLLYm+e/nj/fp6nc57nOc/lnIeh98wz5zzP73v5fD/fz/dz/f54maOvx/NNxjaYiWnFZ4Pi2XI8gaV4AHdjdY/pG3VMw6H4kSxoLSpDPvV+q+BZ/AlfxNsxfiwIHAsJWAcH4ljsjnWxDNfgFizGvXgEjwsDoB+vxBbYHDtgJ7yxZoyf4nzcOgZ0d40p+Bjulx38K07Htrpj9FSRop+IVFRwNfbshtjRxmF4SIj7LeYaG+naBKfg4WKu32HrMZinZQzIblRwnYhtLzBJGLEcK/E5OSY9xaF4Ev/G4XpvUWC66IWKKMyZvZh0XXxVVdxf1YtJR8D78B88Zox1wwT8UhZ/uu52fWN8SSzCzZgnlqBTzMY9WFWM1TVeMeT7erhcnJNjuhh3fZwq53cNLsagMPV27NvF2BuKuV2Lo7sYx5FyvicV38fh10LwYR2OuR5OEp3xnJzdgeJZHw4RZ6mCG8WH6ASTca0w4YAOx3BQQcj2xfezhehjOxhrXNFvaTHmFeLcNGp7zJC2nViWKfgjnsabOujv9QUBh8uOV8QlbQflrt6j9V3tF+vyl6LPSlVpmdPm/DPEN3nQ8OM8IsaLMjkHK/B72Z1W8U78WfVc7zNC+34cjDtr+hwoXuCpEiStwXexWRt07ChMvLSNPs/jdrGt38OncJbogZ9rrP13xUJZxH0iQc00e5+c09uKPncKI4b22biY/xlxh88Vr7AVnFKM/d4W2z+PecL1MjpbIcHMWXXabotfFe3+juM1j976RNuX2n+xiH4jZo3Hcaru9nOipE+TiLMZxomZ/adYoLYwE2+TCK0eca/DhaJxHxVJmVSnXS32LgiqiH6YJxFkPYwXpVgGWDdKnDELC4QRy/BJTGwy565F/9NGoK1lbIrzRE88JU7RBk17sBcWFYQswREaL3ycmOL7ivaLRK8MxXbim1REOj6gseRdKlKz0Qh0johdRCmtFJd4+gjt58rOlSHy0Ror1HXwfvEOKyIp726BprdIMFbB9eKxDsW2xfOTWxivKUqOlyI/uUG7PWuIegDzNd6dfjG3i4v2g6IjWnW1B+QolvrqkAbtrpFQuh2LNgyDogxLpfcIPqF69ncrJqqIQ/NBjUPV/oLYu4r2t4n5a3Xhs/BDUdbLxWxXcGKD9u8pnu/V4vh1MahqV3cS01gRLXul6nn8sPqiSBZ4kJjaZuavEWbiAln4UzhTTOXUYryTGvSbKHrgBy3OUxe1DCixC24qJv+M+P310If9JKdXEY+vmfkbii3wHQnIVohJrvUHRmIAXCRS23HkWY8BxBKs0lh895GjU5q/wzW2AkPxWkmGrhL//hxJoA5FKww4qmjTKB4ZEY0Y8HmxDEMxBVdpzfwNxWvwzWLcZ8TqNEvAtMKA2UWbj9ClNmwRHxKLsFKiyh+rpsIbYVN8WixHH76NM0S3dIt7JXO0Pd1lYFrFVqKhB2U379bYF5iBr4gDdJwouq1EoY7G4qkewTn0hgF94jjtLE7RMonqlsgix4kGP1MWfryEv1uLCV06BjTdr4gqe8GAWlwppnNfEcNv4W+yyI9L8WNA9MR9Y0jHUlGi/b1mQInLJNOzv8QQg5KEOVrc5bHGCtn8iS8UA8hZ/IVo95vkSPQKzxR//4cBW4rGfjmg9FVW1zJgP3xd7HY3A8+WcvZIeYEXElOLvytrTdEyWcB08a/bxS0S7d1dfF+MPTqlcIwxTWKCZ2sZ8HDNw05wiURZm4i7eoFUbx+Q8/5iwuaK9dYy4BoJRW/vYuArav5/TELmN+gy+hoDzFYo3VodsFZEeLdRmuRqMW37i0v7YsFEUfh3MNwdnS92ecdRmuzB4vNiws6y0Tcz3BNcKEHCxj0mqpfYXbLJCxnOgN8Uvw146aJMyy9jOANuEqV1Q4+J6hXmiIRfXP5QzxXul2xuo2OwWnfO0liipGtVg+fzRPwvajbIVmIRPtvg+RnFIOcZnesxj0mtr1vsIc7YavVvjk2SuwmXtTLYJUXjeuWmCZKTWylR1Zk6KD/XoFsG7CB3lco0/H4N2p1QtJnbyqDbSea22cK2FAdnrVxQOlnjIkkzdMqAOfiZSOMjUgtolI2eLHmHtnVbGa83wzZSMi9rAydo785euwzYTDJKayTTdKqRq75fKOhrKzaZID59q5cL3iwXKSqScjpSa9nfVhmwSdHuWYnnz9aavzJQ9FnQQtthOFEWdEQbfeaqFknukgsQzUpdIzFgmpS1nxQFdz5e3SItE+SmyqM6VNj9EiQtbLNfWfoq7/oskhxBPTRiwESpOS6Tc75AaoHt4Nxi/oPb7DeMkA3wLtVEQqtYR/J8ZUhcJkVrMZQBQ2+DXC5KuV3ML/p/o4O+w7Ce6INF2mcCEcWP4l+ym5eq2uqSAWWJvLwbcL3U/TvBPnJcrjKKL1rsLbb/ui4GnSLF08dFi39fsk/XqhZMby3m6hT7i5K8WefJnYY4UAjsduCN5J7w06qXGpaIBHSTqT5Kdn7QKFyFaYYDRMN3KqIlpot//g7dieq6+JrqSxSdHNO2MFOSn2vkhtYLia3lPmNFqsc9e3FiipzhsoQ10mWp0cYk1TsJy3Rp6rrFnrIDl+ni4kGLmCgvZ/2jmHOB3jN/GMZLPb90Wq6V627NLi+2i1n4sgQ+FQlsdh3F8UcF64tOWCJEPiHZl/lyq7SdN0ymSvByhqqJXCOB11tHi+CxetGpT5KPB4tdnlH8/qSko++XnSxfniDSMkN89lmSmOmTRf9BFn6hRJyjSmgvMCDiun3x/5YS3dXWDyviFT4kJfI7RLvfII7TSxYbGgOP7f9oEf8F+KIzdTy1rrAAAAAASUVORK5CYII="
                        />
                      </defs>
                    </svg>
                    <Form.Group>
                      <div className=" ps-4">
                        <h4 className="font24">
                          Was the item delivered and returned on time ?
                        </h4>
                        <div className="starslist smallsize">
                          <ReactStars
                            className="star_rating"
                            size={24}
                            count={5}
                            half={false}
                            name="transport"
                            onChange={(e) => {
                              setFieldValue("transport", e);
                            }}
                            value={values?.transport}
                            color2={"#16ff96"}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>

                  <div className="d-flex mb-5 ratingcards">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xlink="http://www.w3.org/1999/xlink"
                    >
                      <rect width="40" height="40" fill="url(#pattern0)" />
                      <defs>
                        <pattern
                          id="pattern0"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            href="#image0_3522_22680"
                            transform="scale(0.015625)"
                          />
                        </pattern>
                        <image
                          id="image0_3522_22680"
                          width="64"
                          height="64"
                          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAEXklEQVR4nO3aS6hVVRjA8d+1LFOvloNKqYgoNVPDR1oRjZw08EENgsga1bRRD+hBWUFhJiIkQdkwjAapg8gsiyBoEJSl9iDKa2lBZvjCR3kbrLU52+vZ23P23fs8aP9hsQ57rb3Wt769v7W+79uHmpqampqampqampqa/yEDXZz7KszGXMyJv6fhczyDbzohRCcUMIjpuAmzYn0Lrsi55wSewLqqhStTARcKC50jPNXZ8fe1GfMcEp7yLuzEt/gDj+Kh2GcTHsbhEuU8i6IKuEx4kgs0nuo8jG/S9zR+FBa6G1/G3z9jOGP8e/AmJmMv7sUXBWVtmeFRln/wE7biJTwgKOaCgvJMx1dx7BN4RMUm2+6C38fLWIn5GFeBTJfgjdSc7wpvRSUkk5TVr0zux5E4717cVsUkvawAmIGv49yn8biSTaLXFUAws3UpGTZjSlmDN1tYq9c6zUoNkxjC7WUM2k8KIJjETg2TeBZjRvRpS9Z+UwDB73hLQ6YtmJhq7xsFXCn4/6/jSdwl31UeyYM4GuXalLreFwq4HPtS46bLb4Jj9RxW4JqccRZrOGSJR9oXCngxjrcL9+EpvIdfNVdKK2VqEVm7cQwOaMQEdzdpn4qlwga3Fb8bnQJyZe+GAm6IY/2tGld6JOfIPvLY6DQXxfoULu2mIHTPBJKzPKvsx6vy35Cj2IPtgos8M6Nfz5kAXIdt+Fe+Ita0IFO67MCidgRpd6d9Wji/y2K8kGgZWZZrvAlZTBA8w+VC+Hww3nMGGzRMLZcix81JvI07Wl1lQdp96waxCsfifZ8qMWgagyV4R3A6EuH2CFmbCWVNlCJPAXltc/FLbP9Mi29CO1wvbFCHUoIcwlohpVUWRRVASLUPxT6vlSjTWUwQsrdJwiKxvw+wzOiO28RXSO8B4wQlH0jNl3dazBPM4YyQkq+UO4WA5FRKuCP4q2A5GcdYnZpjrex9Keu0eD62f1zKKltgmhDE7FVsg00/2VdwcWrs5Mmnn+Zi574paSZpnA4zRru4bpNl9+fbDzbG9seSC912hctmQH6idEuslyQX+lUBB2LdlqcnHNXk5xX6gjWKxQyDsW9l3xrL4LAg5GBOn3GCEvZrL2boCwV8LwjZriN1vlOAsPsP47vkQi/uAftifWOb9yVfj6fm9JkV66HkQi8q4MNYL83pUzQkXxbrbQXu7RgzhcX9KTgvzUhsP30K3CrfBCZrOEJlximVsEMQdFVGe7NTICmrM+55IbZvL1XSilgkBC7HhEBmJM1OgWYuc8J8HI9jLqhA3krYICxsSIgrsmgnHF5fmnQdYKwQuQ0LH0kWZvTLU8DNKk6IVM0UfCIs4JgQ0mZtjGkmCV+cjmskSEtLiXWasUIm54ywmIPCP8hWCCfGxFhmxmsbhTxCkpRZH8foexbiI63nEbZrYcPr5l9li5Kkv5fgauEvt4R9Yp/gSG3GD12RrqbP6EUTKOLjF2GA3gyGampqOsd/d4nyZZEfMTsAAAAASUVORK5CYII="
                        />
                      </defs>
                    </svg>
                    <Form.Group>
                      <div className=" ps-4">
                        <h4 className="font24">
                          What was your overall rating of the rental ?
                        </h4>
                        <div className="starslist smallsize">
                          <ReactStars
                            className="star_rating"
                            size={24}
                            count={5}
                            half={false}
                            name="rating"
                            onChange={(e) => {
                              setFieldValue("rating", e);
                            }}
                            value={values?.rating}
                            color2={"#16ff96"}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                </>
              )}
              <div className="d-flex align-items-center justify-content-center">
                <Link
                  className="btn btn-theme height42 width200"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                >
                  Next
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
      {loading ? <Loader /> : null}
    </>
  );
};

export default AddRatingmobile;
